import { Skeleton } from "src/component/Skeleton/Skeleton"

const MedicineCostSkeleton = () => {
    return (
        <div className='d-flex justify-content-center align-items-center gap-5'>
            <div className='d-flex justify-content-center align-items-center flex-column text-center font-size-14  m-auto' >
                <Skeleton variant='rounded' height={19} width={50} className='mb-1' />
                <Skeleton variant='rounded' height={19} width={40} />
            </div>
            <div className='d-flex justify-content-center align-items-center flex-column text-center font-size-14  m-auto' >
                <Skeleton variant='rounded' height={19} width={50} className='mb-1' />
                <Skeleton variant='rounded' height={19} width={40} />
            </div>
        </div>
    )
}

export default MedicineCostSkeleton